// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3172":"3c184dafcd6dc004841a","3245":"2e3ca4c7b56b263d06e4","7166":"646434d2654dafd764ee","9640":"8dff195d4f42f01fb44b"}[chunkId] + ".js";
};